<template>
  <v-row dense>
    <v-col cols="3">
      <comapny-image
        v-model="form.upload"
        class="mt-2"
        avatar
        :label="$t('COMPANIES.IMAGE')"
        :url="`uploads/companies`"
        :name="form.name"
        prepend-icon="mdi-camera"
        chips
        show-size
        :readonly="readonly"
        destroyed
        @uploadIds="form.upload_id = $event"
        @removeFile="$emit('removeFile', $event)"
      />
    </v-col>
    <v-col cols="9">
      <v-spacer />
    </v-col>
  </v-row>
</template>

<script>
import formEditable from '@/modules/_global/mixins/form-editable';
import { maxLength, notEmoji } from '@/modules/_global/variables/rules';
import ComapnyImage from '@/modules/companies/components/Image/ComapnyImage';
import company from '@/modules/companies/mixins/company';

export default {
  name: 'CompanyImageForm',

  components: { ComapnyImage },

  mixins: [formEditable, company],

  data() {
    return {
      form: {
        info: ''
      },
      rules: {
        info: [maxLength(1500), notEmoji]
      }
    };
  },

  watch: {
    'form.upload': {
      deep: true,
      immediate: true,
      handler: 'emitter'
    }
  }
};
</script>
